<template>
  <div class="privacy-page">
<h2>プライバシーポリシー</h2>
<div>株式会社ザッパラス（以下、「当社」と言います）は、当社が提供する、以下のサービス及びこれらに関連する全てのサービス（以下、まとめて「本サービス」といいます）にて取得する利用者情報を、当社<a href="https://www.zappallas.com/privacy/" target="_blank">個人情報保護方針</a>に基づき以下の通り管理します。本プライバシーポリシーの内容と本サービスの<a href="/terms">利用規約</a>の内容が異なる場合は、本プライバシーポリシーを優先するものとします。なお、利用者が本サービスによる利用者情報の提供を希望されない場合は、本サービスをご利用になれませんので、予めご了承下さい。<br><br>
  ・「占いフェス」【WEBサイト】<br>
  ・「超運ランキング」【WEBサイト】<br> 
  ・「占いTV」【WEBサイト】
</div>
<dl>
<dt>1条　情報を取得し管理する本サービス提供者等の情報</dt>
<dd>個人情報に関する管理者は、個人情報管理責任者より委任された、管理担当の取締役が担当いたします。</dd>
<dt>2条　取得される利用者情報の項目</dt>
<dd>利用者より、氏名、ニックネーム、電子メールアドレス、生年月日、出生場所等占いを行うのに必要な情報、広告識別子、クレジットカード決済時のカード識別情報、本サービスにおける利用者のアクションに関する情報等を取得します。また、本サービスでは利用者の利便性の向上や広告配信のためにクッキー（Cookie）を使用いたします。詳細は別途定める<a href="/cookie">クッキー（Cookie）利用について</a>をご確認ください。</dd>
<dt>3条　取得方法</dt>
<dd>利用者情報の取得は、本サービス登録画面または商品購入画面への直接入力又は本サービスによる自動取得、及び利用者がSNS認証を使用した場合は当該SNSのAPIにより行います。</dd>
<dt>4条　利用目的の特定・明示</dt>
<dd>利用者情報は、本サービスへのログイン、本サービス上で行う占い、商品のご購入に関する連絡と商品のお届け、本サービスの内容に関する情報配信、キャンペーン実施、本サービスへのお問い合わせ対応の他、広告配信・表示、マーケティング目的、統計分析、本サービスの利用状況解析に利用させていただきます。</dd>
<dt>5条　通知・公表又は同意取得の方法、利用者関与の方法</dt>
<dd>通知・公表
  <ul><li>本プライバシーポリシーは本サービスのページ下部に設置されたテキストリンクからアクセスできます。重要な変更があった場合は、サイト内で告知を行います。</li></ul>
</dd>
<dd>同意取得の方法
  <ul><li>本サービスの利用規約、本プライバシーポリシーをご確認になり、同意の上で本サービスをご利用ください。本サービスをご利用すること(変更後の本プライバシーポリシーについては、変更後にも本サービスを継続利用すること)で、本プライバシーポリシーに同意されたものとみなされます。</li></ul>
</dd>
<dd>利用者関与の方法
  <ul><li>ご本人による本プライバシーポリシーのお問い合わせは、下記10のお問い合わせ窓口よりご連絡ください。</li></ul>
</dd>
<dt>6条　共同利用</dt>
<dd>当社は以下の通りに個人情報を共同利用することがあります。
<ol>
  <li>共同して利用する者の範囲
    <ul><li>当社グループ各社（グループ各社の詳細については<a href="https://www.zappallas.com/projects/" target="_blank">こちら</a>をご覧ください）</li></ul>
  </li>
  <li>利用する者の目的
    <ul>
      <li>新たなサ－ビス・商品等の開発のため</li>
      <li>商品・サービスに関するご案内のため</li>
      <li>グループ各社の提供する商品･サービスについて、利用者からお問い合せ、ご利用申込、その他お申し出があった場合に担当会社へ伝達・引き継ぎを行うため</li>
      <li>その他利用者等とのお取引を適切かつ円滑に履行するため</li>
    </ul>
  </li>
  <li>共同して利用する個人情報の項目
    <ul><li>氏名、生年月日、出生場所、出生情報など占いを行うのに必要な情報、本サービスにおける利用者のアクションに関する情報等</li></ul>
  </li>
  <li>個人情報の管理について責任を有する者
    <ul>
      <li>株式会社ザッパラス<br>
      東京都渋谷区千駄ヶ谷３ー５１ー７<br>
      代表取締役　川嶋　真理</li>
    </ul>
  </li>
</ol>
</dd>
<dt>7条　利用者情報の委託</dt>
<dd>利用者情報は、当社と秘密保持契約を締結した当社協力会社へ業務処理を委託する場合があります。</dd>
<dd>利用者がカード決済をご利用いただく場合には、利用者のカード番号（全桁）、カード名義人、セキュリティコードを、決済処理を行うために情報処理会社及び決済サービス提供会社に提供いたします。なお、この場合はインターネットにて暗号化した上で提供いたしますので、当社で保管しておりません。</dd>
<dt>8条　外部送信・第三者提供・情報収集モジュールの有無</dt>
<dd>利用者に適した広告配信のため、広告配信会社等が提供する情報収集モジュールを使用し、広告識別子を端末から自動取得し、当社の保有する匿名加工利用者情報を広告配信会社等の広告配信システムに提供することがあります。</dd>
<dt>9条　個人情報の第三者への提供・開示</dt>
<dd>上記7条、8条および以下の場合を除き、当社は個人情報をザッパラスグループ会社以外の第三者に提供・開示いたしません。
  <ol>
    <li>利用者ご本人の同意がある場合</li>
    <li>法令に基づき開示、提供を求められた場合</li>
    <li>人の生命、身体または財産の保護のために必要な場合であって、利用者の同意を得ることが困難である場合</li>
    <li>国または地方公共団体等が公的な事務を実施する上で、協力する必要がある場合であって、利用者の同意を得ることにより当該事務の遂行に支障が出るおそれがある場合</li>
    <li>合併、会社分割、営業譲渡その他の事由による事業の承継に伴って、提供する場合</li>
    <li>利用者ご自身がザッパラスグループのホームページ等で、あらかじめ次の内容について容易に確認できる状態にあり、提供を拒否する意思表明がないことを条件に、法令に基づく手続きに従い提供する場合
      <ul>
        <li>第三者への提供を利用目的とすること</li>
        <li>第三者に提供される個人データの項目</li>
        <li>利用者からの申し出があった場合、第三者への提供を停止すること</li>
        <li>利用者からの申し出を受け付ける方法</li>
      </ul>
    </li>
  </ol>
</dd>
<dt>10条　お問合せ窓口</dt>
<dd>登録いただいた利用者情報の開示等、苦情・相談に関するお問い合わせは、以下よりご連絡いただけます。
  <ul><li>お問い合わせ先：Email:<a href="mailto:privacy@zappallas.com">privacy@zappallas.com</a></li></ul>
</dd>
<dt>11条　本プライバシーポリシーの変更</dt>
<dd>当社は、本サービスのバージョンアップ等に伴い利用者情報の取り扱いに変更が生じた場合、必要に応じて本プライバシーポリシーを変更することがあります。変更内容等は、変更後の本サービスに付随するプライバシーポリシーをご参照ください。</dd>
</dl>
<p class="note">
  2019年11月21日 制定<br>
  2020年4月30日 改定<br>
  2020年11月30日 改定<br>
  2022年2月17日 改定<br>
  2022年7月1日 改定<br>
  2023年1月6日 改定
</p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPage",
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.privacy-page {
  color: $col_base_black;
  font-size: 13px;
  line-height: 1.7;
  padding: 1px 4px 30px;
  h2 {
    font-weight: bold;
    font-size: 21px;
    text-align: center;
    margin: 45px 0 30px;
  }
  dl {
    padding: 0;
    margin: 0 0 1em;
    > dt {
      font-weight: bold;
      font-size: 13px;
      margin: 1.6em 0 1em;
      counter-reset: counter;
    }
    > dd {
      margin: 0 0 1em 1.3em;
      text-indent: -1.3em;
      &::before {
        counter-increment: counter;
        content: counter(counter) ". ";
        text-align: justify;
      }
    }
  }
  ol {
    padding: 0;
    margin: 1em 0;
    counter-reset: ulist;
    > li {
      list-style: none;
      padding: 0 0 0.5em 2em;
      text-indent: 0;
      position: relative;
      &::before {
        position: absolute;
        width: 2em;
        margin-left: -2.4em;
        text-align: right;
        counter-increment: ulist;
        content: "(" counter(ulist) ") ";
      }
    }
    ul > li {
      margin-left: 0;
    }
  }
  ul {
    padding: 0;
    margin: 1em 0;
    > li {
      list-style: disc inside;
      margin: 0 0 0.5em 1.7em;
      text-indent: -1.3em;
    }
  }
  .note {}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Privacy.vue